import { globalHistory } from '@reach/router'

export const useRedirectLink = () => {
  const path = globalHistory.location.pathname
  const productPathName = path.split('/')[1]

  return `/${productPathName}` === path ? '/' : `/${productPathName}`
}
